import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {ngcAnimations} from '@app/core/comp/animations';
import {RoleType, SCHOOL_PASSPORT_AUTH_COOKIE_NAME} from '@app/core/model/user';
import {Subscription, timer} from 'rxjs';
import {environment} from '@env/environment';
import {SplashScreenService} from '@app/core/service/splash-screen.service';
import {AuthenticatedUserService} from '@app/core/service/authenticated-user.service';
import {CookieStorage} from '@app/core/security/cookie-storage';
import {AuthenticationService} from "@app/core/service/authentication.service";
import {OidcSecurityProxyService} from '@app/core/service/oidc.security.proxy.service';

@Component({
    selector: 'ngc-login-as-selector',
    templateUrl: './login-as-selector.component.html',
    styleUrls: ['./login-as-selector.component.scss'],
    animations : ngcAnimations
})
export class LoginAsSelectorComponent implements OnInit, OnDestroy {

    private SCHOOL_PASSPORT_AUTH_COOKIE_NAME = SCHOOL_PASSPORT_AUTH_COOKIE_NAME;
    private subscriptions: Subscription[] = [];
    initialized = false;

    constructor(private authenticatedUserService: AuthenticatedUserService,
                private authenticationService: AuthenticationService,
                private splashScreen: SplashScreenService,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private cookieStorage: CookieStorage,
                private oidcSecurityProxyService: OidcSecurityProxyService
    ) {
    }

    ngOnInit(): void {
        if (this.authenticatedUserService.isAuthenticated()) {
            this.router.navigate(['']);
        } else {
            if (localStorage.getItem('lastAuthenticatedUserRole') !== null) {
                localStorage.removeItem('lastAuthenticatedUserRole');
            }
            this.subscriptions.push(
                this.activatedRoute.data.subscribe((data: Data) => {
                    if (data.launchDistrictLogin) {
                        this.authenticationService.checkETXAuth();
                        if (this.checkAuth()) {
                            this.subscriptions.push(
                                timer(0, 1000)
                                    .subscribe(res => {
                                        this.checkAuth();
                                    })
                            );
                        }
                    } else {
                        localStorage.removeItem('lastAuthenticatedRole');
                        this.initialized = true;
                    }
                })
            );
        }
    }

    checkAuth(): boolean {
        const etxAccessToken = this.cookieStorage.read(this.SCHOOL_PASSPORT_AUTH_COOKIE_NAME);
        if (!etxAccessToken) {
            this.loginWithSchoolPassport();
        }
        return !!etxAccessToken;
    }

    loginWithSchoolPassport() {
        localStorage.setItem('lastAuthenticatedRole', RoleType.INSTITUTIONAL_ADMIN);
        if (environment.stsServer) {
            const returnUrl = this.activatedRoute.snapshot.queryParamMap.get('returnUrl');
            if (returnUrl) {
                this.oidcSecurityProxyService.authorize();
            } else {
                window.location.href = environment.etxBaseURI;
            }
        } else {
            this.router.navigate(['login/district'], {queryParams: this.activatedRoute.snapshot.queryParams});
        }
    }

    internalLogin() {
        localStorage.setItem('lastAuthenticatedRole', RoleType.APPLICATION_ADMIN);
        this.router.navigate(['/login/vendor'], {queryParams: this.activatedRoute.snapshot.queryParams});
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
